import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { AccountLifetimeAllowanceClient } from "../../../../../../Wrap/Api/Account/AccountLifetimeAllowance";
import { AccountLifetimeAllowanceDispatcher, AccountLifetimeAllowanceStore } from "../../UpdateLifetimeAllowanceWizard/Store/Variable";

export class AccountLifetimeAllowanceAction {

    public static getInstruction(subAccountHierarchyId: string): void {
        const client = new AccountLifetimeAllowanceClient();

        const promise = client.get(subAccountHierarchyId);

        promise.onSuccess((result) => {
            let data = JSON.parse(JSON.stringify(AccountLifetimeAllowanceStore.getData()));
            if (!data) {data = {};}
            data = result;
            AccountLifetimeAllowanceDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: data,
            });
        });

        promise.onError((err) => {
            AccountLifetimeAllowanceDispatcher.dispatch({
                actionType: ActionType.Error,
                payload: err,
            });
        });
    }
}
